import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-refetch'
import { checkNextPropsPromise, connectDefault } from '../utils/utils'
import * as actions from '../actions/index'
import * as styles from '../styles/styles'
import { auth0 } from '../utils/Auth0'
import { talkdesk } from '../utils/Talkdesk'

class Account extends Component {
  static propTypes = {
    adminBaseUrl: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props, context) {
    super(props, context)

    this.state = {
      name: null,
      screen_name: null,
      picture: null,
      email: null
    }

    this.logout = this.logout.bind(this);
  }

  logout() {
    auth0.logout()
    talkdesk.logout()

    window.location.href = window.location.href.split('/').slice(0, 3).join('/')
  }

  componentWillMount() {
    this.props.dispatch(
        actions.setTopbarButtons([
          { key:"ACCOUNT_LOGOUT", title: "Logout", icon: "power_settings_new", action: this.logout }
        ])
    )

    this.props.fetchProfile()
  }

  componentWillReceiveProps(nextProps) {
    if (checkNextPropsPromise(this.props, nextProps, 'profile')) {
      if (nextProps.profile.fulfilled){
        const profile = nextProps.profile.value.profile
        const { name, first_name, picture, email, screen_name } = profile

        this.setState({name: (name ? name : first_name), picture, email, screen_name })
      }
    }
  }

  render() {
//    console.log("PROFILE", this.state)

    const { picture, name, screen_name, email } = this.state

    return (
      <div>
        <h4>
          {picture ? <img alt="profile" src={picture} style={styles.account.avatar}/> : ''}
          {name ? name : ''}
        </h4>

        {email ? <div>Email: {email}</div> : ''}
        {screen_name ? <div>Screen Name: {screen_name}</div> : ''}
      </div>
    );
  }
}


export default connect.defaults(connectDefault)(props => {
  return {
  fetchProfile: (channelId = props.channelId) => ({
    profile: {
    title: 'Fetch Profile',
    dispatch: props.dispatch,
    url:`${props.adminBaseUrl}/admins/me`,
    refreshing: true, force: true
    }
    })
  }
  })(Account)



// WEBPACK FOOTER //
// ./src/containers/Account.js